export const ENROLL_URL =
  "https://stan.store/DaniGutierrez/p/the-embodied-creator-";

export const openEnroll = () => {
  window.open(ENROLL_URL, "_blank", "noopener");
};

// Stripe checkout is still wired end-to-end (backend + setup_stripe.py).
// To switch back from the Stan link:
//   import { goToCheckout } from "@/lib/checkout";  // kept below
//   goToCheckout("embodied_full_1500") for pay-in-full / ("embodied_plan_800") for the plan.
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const goToCheckout = async (lookupKey) => {
  try {
    const { data } = await axios.post(`${API}/payments/checkout`, {
      lookup_key: lookupKey,
      origin_url: window.location.origin,
    });
    window.location.href = data.checkout_url;
  } catch (e) {
    toast("Could not start checkout", {
      description: "Please try again in a moment — or apply for a spot below.",
    });
  }
};
